function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgQbdIconSquare = function SvgQbdIconSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2ca01c"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.331 12.22c-4.296 0-7.78 3.484-7.78 7.78s3.477 7.774 7.78 7.774h1.112v-2.886h-1.112c-2.697 0-4.888-2.191-4.888-4.888s2.19-4.888 4.888-4.888h2.671v15.112a2.888 2.888 0 0 0 2.886 2.886V12.22h-5.557zm13.338 15.554c4.296 0 7.78-3.484 7.78-7.774s-3.477-7.774-7.78-7.774h-1.111v2.886h1.111c2.697 0 4.888 2.191 4.888 4.888s-2.191 4.888-4.888 4.888h-2.671V9.776a2.888 2.888 0 0 0-2.886-2.886v20.884h5.557z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgQbdIconSquare;